import styled from 'styled-components';

export const Container = styled.div`
  font-size: ${({ theme }) => theme.font.sizes.medium};
`;
